<template>
  <div id="app">
    <v-app light>
      <v-toolbar dense fixed>
        <v-menu>
          <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
          <v-list>
            <v-list-tile v-for="item in menu" :key="item.url" :to="item.url">
              <v-list-tile-content>
                <v-list-tile-title class="body-2 pa-1"><v-icon class="menu-list-item">{{item.icon}}</v-icon>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down" v-for="item in menu" :key="item.url">
          <v-btn :to="item.url" flat class="layout-btn">
            <v-icon flat>{{item.icon}}</v-icon>{{item.title}}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <router-view/>
      <v-footer class="pa-3">
        <v-spacer></v-spacer>
        <div>panparawan.com &copy; {{ new Date().getFullYear() }}</div>
      </v-footer>
    </v-app>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "panparawan",
        menu: [
            { url: '/', title: 'home' },
            { url: '/#projects', title: 'projekty' },
            { url: '/#contact', title: 'kontakt' },
          ]
    }
  }
}
</script>

<style scoped>
.layout-btn {
  text-transform: lowercase;
  font-size: 16px;
}
</style>
